import React from 'react';

import { FormControl, Select, MenuItem, Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@mui/icons-material';

import { STATUS_OPTIONS, observationStatuses } from '../../constants/observations';

const useStyles = makeStyles((theme) => ({
  '.makeStyles-select .MuiInput-underline:before': {
    border: 'none !important',
  },
  checkbox: {
    padding: 0,
    paddingRight: 8,
  },
  closeIcon: {
    '&:hover': {
      color: '#333',
      cursor: 'pointer',
    },
    color: '#aaa',
    display: 'none !important',
    padding: 2,
    position: 'absolute',
    right: 20,
    top: 4,
  },
  inputContainer: {
    '& .NativeDatepicker, .NativeDatepicker .MuiBox-root, & select': {
      height: 30,
      width: 140,
    },
    '&:hover>.MuiSvgIcon-fontSizeSmall': {
      display: 'block !important',
    },
    position: 'relative',
  },
  list: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  menu: {
    border: '2px solid #E7E7E7',
    borderRadius: '5px',
    boxShadow: '2px 6px 10px rgba(0, 0, 0, 0.1)',
    paddingBottom: '1rem',
  },
  menuItem: {
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: 'white',
    },
    height: '40px',
  },
  select: {
    '& .MuiInputBase-input': {
      color: '#999',
      fontFamily: 'Roboto',
      fontSize: 13,
      height: '30px',
      padding: '0 5px',
    },
    '&:focus': {
      borderColor: theme.palette.primary.main,
      color: '#444',
      outline: 'none',
    },
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: '#444',
      cursor: 'pointer',
    },
    border: '1px solid #C8C8C8',
    borderRadius: '8px',
    color: '#999',
    height: '30px',
    overflow: 'hidden',
    width: '127px',
  },
}));

const StatusMultiSelect = ({ selectedStatus = [], onChange, className = '', placeholder = 'Status' }) => {
  const classes = useStyles();

  const statuses = { ...observationStatuses };

  const renderSelectedStatusesLabel = (values) => {
    if (!values.length) return placeholder;
    if (values.length === 1) return statuses[values[0]].label;
    if (values.length < Object.keys(statuses).length) return `${statuses[values[0]].label} + ${values.length - 1}`;
    return 'All Statuses';
  };

  const handleReset = () => {
    onChange([]);
  };

  return (
    <div className={`${classes.inputContainer} ${className}`}>
      <FormControl className={classes.select}>
        <Select
          id="statusSelect"
          multiple
          displayEmpty
          value={selectedStatus}
          onChange={(event) => onChange(event.target.value)}
          renderValue={(val) => renderSelectedStatusesLabel(val)}
          MenuProps={{
            anchorOrigin: {
              horizontal: 'left',
              vertical: 'bottom',
            },
            classes: {
              list: classes.list,
              paper: classes.menu,
            },
            getContentAnchorEl: null,
          }}>
          {STATUS_OPTIONS.map((status) => (
            <MenuItem className={classes.menuItem} key={status.value} value={status.value}>
              <Checkbox className={classes.checkbox} checked={selectedStatus.indexOf(status.value) > -1} />
              {status.label}
            </MenuItem>
          ))}
        </Select>

        {selectedStatus.length > 0 && <Close fontSize="small" className={classes.closeIcon} title="Reset Value" onClick={handleReset} />}
      </FormControl>
    </div>
  );
};

export default StatusMultiSelect;
